export const isIphoneLike = /iP(hone|od)/.test(self.window.navigator.userAgent);
